/*
================================================
Une mixin pour les tags
================================================
*/

var  TagMixin = {
    created(){
        // this.hello()
    },

    data: function () {
        return {
            name: 'TagMixin',
        }
    },
    methods: {
        // hello: function () {
        //     alert(`hello ;) "${this.name}" is loaded !`)
        // },

        /**
         * Affiche une liste de tags d'un timerecord sous forme d'une string
         * @param timerecord Object | Un objet timerecord
         * @param offset int | Le décalage à partir duquel on affiche les tags
         */
        displayTagsInline: function (timerecord, offset) {

            let tagsInString = null
            timerecord.tags.forEach(function (tag, index) {

                if (index >= offset) {
                    if(tagsInString==null){
                        tagsInString = '"'+tag.name+'"'
                    }
                    else{
                        tagsInString = tagsInString +', "'+tag.name+'"'
                    }
                }

            })
            return  tagsInString
        }
    },


}

export default TagMixin;

